'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHasNoTimePeriodError = undefined;

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

var _constants = require('../constants');

var _dotstatsuiteSdmxjs = require('@sis-cc/dotstatsuite-sdmxjs');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var getHasNoTimePeriodError = exports.getHasNoTimePeriodError = function getHasNoTimePeriodError(_ref) {
  var data = _ref.data,
      type = _ref.type;

  if (!R.equals(_constants.TIMELINE, type)) {
    return false;
  }
  var dimensions = R.pathOr([], ['structure', 'dimensions', 'observation'], data);
  var timeDimension = (0, _dotstatsuiteSdmxjs.getTimePeriodDimension)({ dimensions: dimensions });
  if (R.isNil(timeDimension)) {
    return true;
  }
  return R.pipe(R.propOr([], 'values'), R.length, R.gte(1))(timeDimension);
};